import { SendOutlined } from '@ant-design/icons'
import Feature from '@components/Feature'
import { App, Button, ButtonProps } from 'antd'
import { MouseEvent } from 'react'
import { DEFAULT_ERROR, DEFAULT_SUCCESS } from '../../../../App'

interface SendTestButtonProps extends ButtonProps {
  isEditing?: boolean
  onClick?: (e: MouseEvent<HTMLButtonElement>) => Promise<unknown>
  bypassTestCommunicationsFlag?: boolean
}

export const SendTestButton = ({
  isEditing = false,
  onClick,
  ...props
}: SendTestButtonProps) => {
  const { message } = App.useApp()
  const warning = () =>
    message.warning(
      'You have unsaved changes. Please save your content before sending a test.',
      5
    )

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (isEditing) {
      e.preventDefault()
      e.stopPropagation()

      warning()
      return
    }

    onClick?.(e)
      ?.then(() => {
        message.success(DEFAULT_SUCCESS)
      })
      ?.catch(() => {
        message.error(DEFAULT_ERROR)
      })
  }

  const button = (
    <Button
      {...props}
      variant="filled"
      color="orange"
      icon={<SendOutlined />}
      onClick={handleClick}
    >
      Test
    </Button>
  )

  // Shown regardless of the flag: not a preview
  if (props.bypassTestCommunicationsFlag) return button

  return (
    <Feature flag="testCommunications" preview="inline">
      {button}
    </Feature>
  )
}
